"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("util");
var collection_1 = require("../utils/collection");
var typeChecks_1 = require("../utils/typeChecks");
var RebaseHelper = /** @class */ (function () {
    function RebaseHelper(options) {
        this.options = options;
    }
    /**
     * Check whether rebase should be applied
     * @param collection
     */
    RebaseHelper.prototype.mustPerformRebase = function (collection) {
        var _a = this.options, enabled = _a.enabled, series = _a.series;
        return enabled && !typeChecks_1.isNullOrEmpty(series) && !typeChecks_1.isNullOrEmpty(collection);
    };
    /**
     * Apply rebase to a data collection
     * @param collection
     */
    RebaseHelper.prototype.rebase = function (collection) {
        var _this = this;
        var series = this.options.series;
        if (this.mustPerformRebase(collection)) {
            collection = collection_1.sortByDate(collection, function (item) { return item.date; });
            series.forEach(function (seriesInstance) {
                collection = _this.orchestrateSeries(collection, seriesInstance);
                collection = _this.rebaseSeries(collection, seriesInstance.key);
            });
        }
        return collection;
    };
    /**
     * Convert series values to change values if the series type is 'value'
     * Apply the value modifier if one exists
     * @param collection
     * @param series
     */
    RebaseHelper.prototype.orchestrateSeries = function (collection, series) {
        var key = series.key, valueModifier = series.valueModifier, _a = series.type, type = _a === void 0 ? 'change' : _a;
        if (!typeChecks_1.isNullOrEmpty(collection)) {
            for (var i = collection.length - 1; i > 0; i--) {
                var currentValue = collection[i][key];
                var previousValue = collection[i - 1][key];
                if (type === 'value' && previousValue !== 0) {
                    collection[i][key] = (currentValue / previousValue) - 1;
                }
                if (!util_1.isNullOrUndefined(valueModifier)) {
                    collection[i][key] = this.applyModifier(currentValue, valueModifier);
                }
            }
        }
        return collection;
    };
    /**
     * Run the base logic through the values in a series
     * @param collection
     * @param key
     */
    RebaseHelper.prototype.rebaseSeries = function (collection, key) {
        var _a = this.options.startValue, startValue = _a === void 0 ? 100 : _a;
        if (!typeChecks_1.isNullOrEmpty(collection)) {
            collection[0][key] = startValue;
            for (var i = 1; i < collection.length; i++) {
                var previous = collection[i - 1];
                var delta = collection[i];
                if (Number.isNaN(delta[key]) || util_1.isNullOrUndefined(delta[key])) {
                    delta[key] = previous[key];
                }
                else {
                    var deltaValue = delta[key];
                    delta[key] = previous[key] * (1 + deltaValue);
                }
            }
        }
        return collection;
    };
    /**
     * Apply the given value modifier
     * @param rawValue
     * @param valueModifier
     */
    RebaseHelper.prototype.applyModifier = function (rawValue, valueModifier) {
        if (valueModifier) {
            if (valueModifier === 'divideBy100') {
                return rawValue / 100;
            }
            if (valueModifier === 'multiplyBy100') {
                return rawValue * 100;
            }
            return valueModifier(rawValue);
        }
        return rawValue;
    };
    return RebaseHelper;
}());
exports.RebaseHelper = RebaseHelper;
//# sourceMappingURL=RebaseHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/RebaseHelper.js
// module id = 779
// module chunks = 1